import React, { useState  } from 'react';
import {  Row,Col   } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils";
import signUp_img from "../images/event/signUp.png"; 
  

const HommainView =  styled.div` 
    color: white;  
    background-color: #000000;
    height:${props => props.height}px;
    position: relative;  
    overflow:hidden;

    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 190px - 190px);
    min-width: 980px;
    `;
 
const SecWrap =  styled.div`   
   `;

const SecContentWrap =  styled.div`  
   position: static;
    display: grid;
    height: auto;
    width: 100%;
    min-height: 710px;
    grid-template-rows: repeat(5, min-content) 1fr;
    grid-template-columns: 100%;
     `;
     
const SecTitle=  styled.div`  
   position: relative;
     margin: 74px 0px 10px calc((100% - 490px) * 0);
     left: ${props => props.left}px;
     grid-area: 1 / 1 / 2 / 2;
     justify-self: start;
     align-self: start;
     font-size: ${props => props.fontSize}px;
     line-height: normal;
     letter-spacing: normal;
     `;

      
const SecP=  styled.span`  
position: relative;
margin: 0px 0px 64px calc((100% - 490px) * 0);
left: ${props => props.left}px;
grid-area: 3 / 1 / 4 / 2;
justify-self: start;
align-self: start;
font-size: 18px;
line-height: 1.6em;
       `;

 

const EventCenterView = ({image,title,rightContent,leftContent,Name,buttons}) => { 
    
    return (<HommainView  id={"EventCenterView"}> 
    
        <div> 
            {DeviceUtils.isMobile()===true?
            <div className="pt-3">
                <img src={image} style={{width:`${window.innerWidth}px`, objectFit:"cover",objectPosition: "50% 50%"}}/> 
            </div>:<img src={image}    style={{ width:`100%`, objectFit:"cover",objectPosition: "50% 50%"}}/>} 
        </div>
        
        {(DeviceUtils.isMobile()===true)?
        <div>
            <SecTitle 
                        fontSize={(DeviceUtils.isMobile()===true)?24:34}
                        left={(DeviceUtils.isMobile()===true)?28:79}
                        className="newpageP_b">
                            <b>{title}</b>
            </SecTitle>


                {/* //手機 */}
                        <div style={{
                            fontSize:'18px',
                            paddingLeft:'28px', 
                            paddingTop:`${(DeviceUtils.isMobile()===true)?15:80}px` ,
                            fontFamily: "'Barlow:wght@200', 'Barlow', sans-serif",
                            width:`${(window.innerWidth-28)}px`
                            }}>
                                {rightContent} 
 

                                
                        </div> 

                           
                <SecWrap  >   
                    {leftContent} 
                </SecWrap> 
        </div> 
        :<Row className="p-0 m-0" >
            <Col className="p-0 m-0" >
                <SecWrap  >   
                    <SecContentWrap >
                        <SecTitle 
                        fontSize={(DeviceUtils.isMobile()===true)?24:34}
                        left={(DeviceUtils.isMobile()===true)?28:79}
                        className="newpageP_b">
                            <b>{title}</b>
                        </SecTitle>
                         
                        <SecP   
                        left={(DeviceUtils.isMobile()===true)?28:79}
                        style={{
                            paddingTop:`${(DeviceUtils.isMobile()===true)?15:80}px` ,
                            fontFamily: "'Barlow:wght@200', 'Barlow', sans-serif",
                            width:`650px`}}>
                            <span>
                                {rightContent} 
                            </span> 
                        </SecP> 
                    </SecContentWrap>
                
                        
                </SecWrap>
            </Col> 
            
        </Row>}

                <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSc9SWjS9cHIhPHxRpZbfly5z2z_JeTN7O-xHR-ZfLPWJs4bHg/viewform" >
                    <div> 
                        {DeviceUtils.isMobile()===true?
                        <div className="pl-3"  >
                            <img src={signUp_img} style={{width:`${(window.innerWidth -80)}px`, objectFit:"cover",objectPosition: "50% 50%"}}/> 
                        </div>:<div className="pt-5 pb-5" style={{paddingLeft:"79px"}}>
                            <img src={signUp_img} style={{ width:`${354}px`, objectFit:"cover",objectPosition: "50% 50%"}}/>   
                        </div>} 
                    </div> 
                </a>
       </HommainView>);
};

export default EventCenterView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/event/EventCenterView.js